<aside class="position-fixed main-sidebar">
  <div class="sidebar">
    <a class="user-panel" href="/gestao/conta" title="Abrir gestão da conta"><div class="avatar">{{token?.nome?.charAt(0) || 'U'}}</div><div><strong>{{token?.nome}}</strong><span><i></i> Online</span></div></a>
    <div class="menu-label">NAVEGAÇÃO PRINCIPAL</div>
    <nav class="mt-2" *ngIf="tipoSaas != 2 && !isSdr">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <li class="nav-item ">
          <a href="/" [ngClass]="{'ativo': ativo == 'Home'}" class="nav-link">
            <i class="nav-icon fa fa-home"></i>
            <div class="texto-link" [ngClass]="{'ativo': ativo == 'Home'}">Dashboard</div>
          </a>
        </li>
        <li class="nav-item">
          <a href="/venda-ativa" [ngClass]="{'ativo': ativo == 'VendaAtiva'}" class="nav-link">
            <i class="nav-icon fa fa-phone"></i>
            <div class="texto-link" [ngClass]="{'ativo': ativo == 'VendaAtiva'}">Venda ativa</div>
          </a>
        </li>
        <li class="nav-item">
          <a href="/trabalho/agenda" class="nav-link" [ngClass]="{'ativo': ativo == 'Agenda'}">
            <i class="nav-icon fa fa-calendar-check-o"></i>
            <div class="texto-link" [ngClass]="{'ativo': ativo == 'Agenda'}">Agenda</div>
          </a>
        </li >
        <li class="nav-item">
          <a href="/cadastro/atendimento" [ngClass]="{'ativo': ativo == 'CRM'}" class="nav-link">
            <i class="nav-icon fa fa-sellsy"></i>
            <div class="texto-link" [ngClass]="{'active': ativo == 'CRM'}">CRM</div>
          </a>
        </li >
        <li class="nav-item">
          <a href="/cadastro/cliente" [ngClass]="{'ativo': ativo == 'Contatos'}" class="nav-link">
            <i class="nav-icon fa fa-users"></i>
            <div class="texto-link" [ngClass]="{'ativo': ativo == 'Contatos'}">Clientes</div>
          </a>
        </li >
        <li class="nav-item">
          <a href="/trabalho" class="nav-link" [ngClass]="{'ativo': ativo == 'Tarefas'}">
            <i class="nav-icon fa fa-check-square"></i>
            <div class="texto-link" [ngClass]="{'ativo': ativo == 'Tarefas'}">Tarefas</div>
          </a>
        </li>
       <!-- <li class="nav-item" [ngClass]="{'has-submenu': showMensagensSubmenu}">
          <a href="#" class="nav-link dropdown-submenu" [ngClass]="{'ativo': ativo == 'Comunicacao'}" (click)="toggleMensagensSubmenu(); $event.preventDefault()">
            <i class="nav-icon fa fa-comments"></i>  <i class="fa angle-icon" [ngClass]="{'fa-angle-down': showMensagensSubmenu, 'fa-angle-right': !showMensagensSubmenu}"></i>

            <div class="texto-link" [ngClass]="{'ativo': ativo == 'Comunicacao'}">Comunicação</div>
            </a>
          <ul class="nav nav-treeview" *ngIf="showMensagensSubmenu" style="margin-left: 15px;">
            <li class="nav-item">
              <a href="/comunicacao/email" class="nav-link" [ngClass]="{'ativo': ativo == 'Email'}">
                <i class="nav-icon fa fa-inbox"></i>
                <div class="texto-link" [ngClass]="{'ativo': ativo == 'Email'}">Email</div>
              </a>
            </li>
            <li class="nav-item">
              <a href="/comunicacao/whatsapp" class="nav-link" [ngClass]="{'ativo': ativo == 'Whatsapp'}">
                <i class="nav-icon fa fa-paper-plane"></i>
                <div class="texto-link" [ngClass]="{'ativo': ativo == 'Whatsapp'}">Whatsapp</div>
              </a>
            </li>
          </ul>
        </li> -->
        <li class="nav-item" [ngClass]="{'has-submenu': showGestaoSubmenu}">
          <a href="#" class="nav-link dropdown-submenu" [ngClass]="{'ativo': ativo == 'Gestao'}" (click)="toggleGestaoSubmenu(); $event.preventDefault()">
            <i class="nav-icon fa fa-cogs"></i>  <i class="fa angle-icon" [ngClass]="{'fa-angle-down': showGestaoSubmenu, 'fa-angle-right': !showGestaoSubmenu}"></i>

            <div class="texto-link" [ngClass]="{'ativo': ativo == 'Gestao'}">Gestão</div>
            </a>
          <ul class="nav nav-treeview gestao-submenu" *ngIf="showGestaoSubmenu" style="margin-left: 15px;">
            <li class="nav-item">
              <a href="/gestao/conta" class="nav-link" [ngClass]="{'ativo': ativo == 'Conta'}">
                <i class="nav-icon fa fa-user"></i>
                <div class="texto-link" [ngClass]="{'ativo': ativo == 'Conta'}">Informações de conta</div>
              </a>
            </li>
            <li class="nav-item">
              <a href="/gestao/conta?secao=usuarios" class="nav-link" [ngClass]="{'ativo': ativo == 'Usuarios'}">
                <i class="nav-icon fa fa-users"></i>
                <div class="texto-link" [ngClass]="{'ativo': ativo == 'Usuarios'}">Usuários</div>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
    <nav class="mt-2" *ngIf="isSdr">
      <ul class="nav nav-pills nav-sidebar flex-column">
        <li class="nav-item"><a href="/venda-ativa" class="nav-link" [ngClass]="{'ativo': ativo == 'VendaAtiva'}"><i class="nav-icon fa fa-phone"></i><div class="texto-link ativo">Venda ativa</div></a></li>
      </ul>
    </nav>
    <ul class="nav nav-pills nav-sidebar flex-column sidebar-rodape">
      <li class="nav-item" *ngIf="!isSdr" (click)="abrirModal()">
        <a class="nav-link">
          <i class="nav-icon fa fa-comment"></i>
          <div class="texto-link">Feedback / Suporte</div>
        </a>
      </li>
      <li class="nav-item" *ngIf="!isSdr">
        <a href="/ajuda" target="_blank" class="nav-link">
          <i class="nav-icon fa fa-question"></i>
          <div class="texto-link">Ajuda</div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="logoff()">
          <i class="nav-icon fa fa-sign-out"></i>
          <div class="texto-link">Sair</div>
        </a>
      </li>
    </ul>
  </div>
</aside>

<app-feedback *ngIf="!isSdr"
  [showModal]="showModalFeedback"
  (fecharModalPai)="fecharModal()"
></app-feedback>
